export const pipelinesKeys = {
	all: ['crm', 'pipelines'],
	list: () => ['crm', 'pipelines', 'list'],
	trash: (filters) => ['crm', 'pipelines', 'trash', filters],
};

export const pipelinesMutationKeys = {
	create: ['crm', 'pipelines', 'create'],
	update: ['crm', 'pipelines', 'update'],
	delete: ['crm', 'pipelines', 'delete'],
	restore: ['crm', 'pipelines', 'restore'],
	createStage: ['crm', 'stages', 'create'],
	updateStage: ['crm', 'stages', 'update'],
	deleteStage: ['crm', 'stages', 'delete'],
	reorderStages: ['crm', 'stages', 'reorder'],
};
